export default __webpack_public_path__ + "static/media/QRCode.b3627ecd.svg";